// utils/slugify.js
export function slugify(text) {
  return text
    .toString()
    .normalize('NFD')                     // Remove acentos
    .replace(/[\u0300-\u036f]/g, '')      // Remove diacríticos
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')                 // Espaços viram hífens
    .replace(/[^a-z0-9\-]/g, '')          // Remove caracteres especiais
}
